export default __webpack_public_path__ + "static/vesdk2-45694c3750bc817a8bff02ee92d85329.png";